import React, {useMemo } from 'react'
import { map } from 'lodash'
import {
  useNavigate
} from "react-router-dom"

import EcsButton from '../../components/Button'
import SectionHeader from '../../components/SectionHeader'
import ClinicCard from '../../components/ClinicCard'
import { generateAddress } from '../../helpers/clinic'

export default({globalData, clinic}) => {
  if (clinic) return null
  const navigate = useNavigate()

  return (
    <div className="mb-8">
      <SectionHeader title={`We have ${globalData.clinics.length} locations to serve you!`} subtitle={'Eye Clinics of Seattle'} />
      <div className="flex flex-wrap gap-4 mb-8">
      {
        map(globalData.clinics, (c, index) => {
          return <div className="px-8 py-4 rounded-xl border flex-1 min-w-[250px]" key={`clinic-${index}`}>
            <h2 className="font-bold text-lg text-sky-500">{c.name}</h2>
            <div className="text-xs md:text-sm mb-4">
            {
              generateAddress(c)
            }
            </div>
            {
              c.bulletinSmall !== null &&
              <div className="text-sm mb-4 ecs-html text-sky-500" dangerouslySetInnerHTML={{__html: c.bulletinSmall.html}}>
              </div>
            }
            <div
              className="text-sm font-bold cursor-pointer"
              onClick={ () => { navigate(c.url)}}
            >
              select this clinic <span className="material-symbols-rounded text-xs">arrow_forward_ios</span>
            </div>
            
          </div>
        })
      }
      </div>
      <div className="home-clinic-button">
        <EcsButton label={"Appointments"} url="/appointments" local={true} />
      </div>
      <div className="home-clinic-button">
        <EcsButton label={"Pay Bill"} url="/pay-bill" local={true} />
      </div>
      <div className="home-clinic-button">
        <EcsButton label={"Order Contacts"} url="/order-contacts" local={true} />
      </div>
    </div>
  )
}


// {
//   !clinic &&
//   <div className="mb-8">
     
//      <div>
//         {
//           map(sortBy(globalData.clinics, (c) => {return c.name}), (c, ndx) => {
//             return (
//               <div 
//                 key={`location-${ndx}`}
//                 className="nowrap hover:cursor-pointer hover:bg-sky-400 hover:text-white inline-block px-8 py-1 border border-sky-400 rounded mr-2 text-sm uppercase font-semibold" 
//                 onClick={() => navigate(`/${c.url}`)}
//               >
//                 {c.name}
//               </div>
//             )
//           })
//         }
//      </div>
//   </div>
// }